module.exports = __webpack_public_path__ + "static/media/mute-icon.b61c53f9.svg";